/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { curry } from 'ramda';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';

export const renderInput = curry(({ label, loading, length, maxLength, required }, params) => (
  <TextField
    {...params}
    label={label}
    required={required}
    slotProps={{
      htmlInput: { ...params.inputProps, maxLength },

      input: {
        ...params.InputProps,
        endAdornment: (
          <>
            {loading ? (
              <CircularProgress size={20} sx={{ color: 'secondary.main' }} />
            ) : !length ? (
              <SearchIcon color="inherit" size={20} />
            ) : null}
            {params.InputProps.endAdornment}
          </>
        ),
      },
    }}
  />
));

// TODO: broken look into fixing when we have time
export const renderTags = curry(({ keyProp, labelProp }, tags, getTagProps) =>
  tags.map(item => (
    <Chip
      {...getTagProps(item)}
      key={item[keyProp]}
      label={item[labelProp]}
      sx={{ borderColor: 'secondary.main', borderRadius: 25 }}
      variant="outlined"
    />
  ))
);
